import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SchedulingStatusService } from './scheduling-status.service';

@Component({
  selector: 'app-scheduling-status-icon',
  templateUrl: './scheduling-status-icon.component.html'
})
export class SchedulingStatusIconComponent implements OnChanges {
  @Input() schedulingStatus: string;
  @Input() size: string;
  @Input() target: string = 'task';

  public title: string = '';
  public color: string = 'transparent'

  constructor(private schedulingStatusService: SchedulingStatusService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selected = this.schedulingStatusService.getSchedulingStatusByValue(this.schedulingStatus);
    if (this.target == 'invoicing-proposal') {
      this.title = 'invoicingProposal.schedulingStatus.' + selected.value
    }
    else {
      this.title = 'task.schedulingStatus.' + selected.value;
    }
    this.color = selected.color;
  }

}
